<div class="app-main__inner">

  <!-- ── Header bar ─────────────────────────────────────────────────────── -->
  <div class="bc-toolbar">
    <!-- Status tabs -->
    <div class="bc-tabs">
      <button *ngFor="let t of tabs" type="button"
              class="bc-tab" [class.bc-tab--active]="activeTab === t.key"
              (click)="switchTab(t.key)">
        {{ t.label }}
      </button>
    </div>
    <button type="button" class="btn btn-primary btn-sm" (click)="openAddModal()">
      <i class="pe-7s-plus me-1"></i> Add Claim
    </button>
  </div>

  <!-- ── Claims table ───────────────────────────────────────────────────── -->
  <div class="card bb-fill-card mt-0">
    <div class="card-body p-0">

      <div class="text-center py-5" *ngIf="isLoading">
        <div class="spinner-border text-primary"></div>
        <p class="mt-2 text-muted small">Loading claims…</p>
      </div>

      <div class="text-center py-5 text-muted" *ngIf="!isLoading && claims.length === 0">
        <i class="pe-7s-bookmarks" style="font-size:2.5rem;opacity:.3"></i>
        <p class="mt-2 small">No claims found.</p>
      </div>

      <div class="table-responsive" *ngIf="!isLoading && claims.length > 0">
        <table class="table table-hover mb-0 bc-table">
          <thead>
            <tr>
              <th>Claim ID</th>
              <th>Member</th>
              <th>Book</th>
              <th>Claimed On</th>
              <th>Status</th>
              <th>Copy #</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of claims">
              <td><code class="small">{{ c.claimId }}</code></td>
              <td>
                <div class="fw-semibold small">{{ c.memberName }}</div>
                <div class="text-muted" style="font-size:.72rem">{{ c.memNo || ('Sr#' + c.memberSrNo) }}</div>
              </td>
              <td>
                <div class="small fw-semibold">{{ c.bookName }}</div>
                <div class="text-muted" style="font-size:.72rem">{{ c.bookId }}</div>
              </td>
              <td class="small text-muted">{{ c.claimedOn | appDate }}</td>
              <td>
                <span [class]="statusBadgeClass(c.status)" style="font-size:.72rem">{{ statusLabel(c.status) }}</span>
              </td>
              <td class="small">
                <span *ngIf="c.status === 'allocated'" class="fw-bold text-primary"># {{ c.allocatedBookSrNo }}</span>
                <span *ngIf="c.status !== 'allocated'" class="text-muted">—</span>
              </td>
              <td class="text-end">
                <div class="d-flex gap-1 justify-content-end flex-wrap">
                  <button *ngIf="c.status === 'pending'" type="button"
                          class="btn btn-sm bc-btn-allocate" (click)="openAllocateModal(c)">
                    <i class="pe-7s-pin me-1"></i>Allocate
                  </button>
                  <button *ngIf="c.status === 'pending' || c.status === 'allocated'" type="button"
                          class="btn btn-sm bc-btn-cancel" (click)="openCancelModal(c)">
                    <i class="pe-7s-close-circle me-1"></i>Cancel
                  </button>
                  <span *ngIf="c.status === 'fulfilled'" class="small text-success">
                    <i class="pe-7s-check me-1"></i>Issued {{ c.fulfilledOn | appDate }}
                  </span>
                  <span *ngIf="c.status === 'cancelled'" class="small text-muted">—</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

</div>


<!-- ═══════════════════════════════════════════════════════════════════════
     ADD CLAIM MODAL
════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showAddModal"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.5);z-index:1060;" (click)="closeAddModal()">
  <div class="card shadow-lg bc-modal-card" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <span class="fw-bold"><i class="pe-7s-bookmarks me-1 text-primary"></i>Add Book Claim</span>
      <button class="btn-close" (click)="closeAddModal()"></button>
    </div>

    <div class="card-body p-3" style="overflow-y:auto;max-height:70vh;">

      <!-- ── Step 1: Member ── -->
      <div class="bc-step-label">Step 1 — Select Member</div>

      <div *ngIf="!selectedMember">
        <div class="input-group input-group-sm mb-2">
          <input type="text" class="form-control" placeholder="Search by name / member no / phone…"
                 [(ngModel)]="memberSearch" (input)="searchMembers()" autofocus />
        </div>
        <div class="bc-result-list" *ngIf="memberResults.length > 0">
          <div class="bc-result-item" *ngFor="let m of memberResults" (click)="selectMemberForClaim(m)">
            <div class="fw-semibold small">{{ m.name }}</div>
            <div class="text-muted" style="font-size:.72rem">{{ m.memNo || ('Sr#' + m.memberSrNo) }} · {{ m.phone }}</div>
          </div>
        </div>
        <div class="alert py-2 px-3 small mb-0 mt-1"
             [class.alert-warning]="memberSearchIsExpiry"
             [class.alert-secondary]="!memberSearchIsExpiry"
             *ngIf="memberSearchError && memberResults.length === 0">
          <i class="pe-7s-attention me-1"></i>{{ memberSearchError }}
        </div>
      </div>

      <div *ngIf="selectedMember" class="bc-selected-box mb-3">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <div class="fw-bold">{{ selectedMember.name }}</div>
            <div class="text-muted small">{{ selectedMember.memNo || ('Sr#' + selectedMember.memberSrNo) }} · {{ selectedMember.phone }}</div>
          </div>
          <button class="btn btn-link btn-sm p-0 text-muted" (click)="selectedMember = null; memberSearch = ''">Change</button>
        </div>
      </div>

      <!-- ── Step 2: Book ── -->
      <div class="bc-step-label">Step 2 — Select Book</div>

      <div *ngIf="!selectedBook">
        <div class="bc-search-type-row mb-2">
          <label class="bc-search-type-opt" [class.bc-search-type-opt--active]="bookSearchType === 'name'">
            <input type="radio" name="bst" value="name" [(ngModel)]="bookSearchType" /> By Book Name
          </label>
          <label class="bc-search-type-opt" [class.bc-search-type-opt--active]="bookSearchType === 'author'">
            <input type="radio" name="bst" value="author" [(ngModel)]="bookSearchType" /> By Author Name
          </label>
        </div>
        <div class="input-group input-group-sm mb-2">
          <input type="text" class="form-control"
                 [placeholder]="bookSearchType === 'author' ? 'Author name…' : 'Book name…'"
                 [(ngModel)]="bookSearch" (keyup.enter)="searchBooks()" />
          <button class="btn btn-primary" (click)="searchBooks()" [disabled]="isBookSearching || !bookSearch.trim()">
            <span *ngIf="isBookSearching" class="spinner-border spinner-border-sm"></span>
            <i *ngIf="!isBookSearching" class="pe-7s-search"></i>
          </button>
        </div>
        <div class="bc-result-list" *ngIf="bookResults.length > 0">
          <div class="bc-result-item" *ngFor="let b of bookResults" (click)="selectBook(b)">
            <div class="fw-semibold small">{{ b.bookName }}</div>
            <div class="text-muted" style="font-size:.72rem">
              {{ b.bookId }}
              <ng-container *ngIf="b.authorNames?.length">
                &nbsp;·&nbsp;{{ b.authorNames[0] }}
              </ng-container>
              &nbsp;·&nbsp;
              <span [class.text-success]="b.copiesAvailable > 0" [class.text-danger]="b.copiesAvailable === 0">
                {{ b.copiesAvailable }} available
              </span>
            </div>
          </div>
        </div>
        <div class="alert alert-danger py-2 px-3 small mb-0 mt-1 d-flex align-items-center gap-2"
             *ngIf="bookSearchError && bookResults.length === 0">
          <i class="pe-7s-close-circle"></i>
          <span class="flex-grow-1">{{ bookSearchError }}</span>
          <button class="btn btn-sm btn-outline-danger" (click)="searchBooks()">Retry</button>
        </div>
        <div class="text-muted small text-center py-2" *ngIf="!isBookSearching && !bookSearchError && bookResults.length === 0 && bookSearch.trim()">
          No books found. Try a different search.
        </div>
      </div>

      <div *ngIf="selectedBook" class="bc-selected-box mb-3">
        <div class="d-flex align-items-start justify-content-between">
          <div>
            <div class="fw-bold">{{ selectedBook.bookName }}</div>
            <div class="text-muted small">
              {{ selectedBook.bookId }}
              <ng-container *ngIf="selectedBook.authorNames?.length">
                &nbsp;·&nbsp;{{ selectedBook.authorNames.join(', ') }}
              </ng-container>
            </div>
            <div class="mt-1 small">
              <span [class.text-success]="selectedBook.copiesAvailable > 0"
                    [class.text-warning]="selectedBook.copiesAvailable === 0">
                <i class="pe-7s-check me-1"></i>{{ selectedBook.copiesAvailable }} copies available at library
              </span>
              <span class="text-muted ms-2" *ngIf="bookQueue.length > 0">
                <i class="pe-7s-clock me-1"></i>{{ bookQueue.length }} in queue
              </span>
            </div>
          </div>
          <button class="btn btn-link btn-sm p-0 text-muted" (click)="selectedBook = null; bookSearch = ''">Change</button>
        </div>
        <div *ngIf="bookQueue.length > 0" class="bc-queue-mini mt-2">
          <div class="bc-queue-mini-label">Current queue:</div>
          <div *ngFor="let q of bookQueue; let i = index" class="bc-queue-mini-row">
            <span class="bc-queue-pos">#{{ i+1 }}</span>
            <span class="small">{{ q.memberName }}</span>
            <span [class]="statusBadgeClass(q.status)" style="font-size:.65rem">{{ q.status }}</span>
          </div>
        </div>
      </div>

      <!-- ── Remarks ── -->
      <div class="mb-2">
        <label class="form-label small fw-semibold">Remarks (optional)</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="addRemarks" placeholder="Any notes…" />
      </div>

      <div class="alert alert-info py-2 px-3 small" *ngIf="copiesAtCurrentCenter > 0 && !addError">
        <i class="pe-7s-info me-1"></i>{{ copiesAtCurrentCenter }} cop{{ copiesAtCurrentCenter === 1 ? 'y' : 'ies' }} available at this center — will be <strong>automatically allocated</strong> to this member.
      </div>
      <div class="alert alert-secondary py-2 px-3 small" *ngIf="selectedBook && copiesAtCurrentCenter === 0 && !addError">
        <i class="pe-7s-info me-1"></i>No copies available at this center. Claim will be kept <strong>pending</strong>.
      </div>

      <div class="alert alert-danger py-2 px-3 small" *ngIf="addError">
        <i class="pe-7s-attention me-1"></i>{{ addError }}
      </div>

    </div>

    <div class="card-footer d-flex justify-content-end gap-2 py-2 px-3">
      <button type="button" class="btn btn-secondary btn-sm" (click)="closeAddModal()">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="submitAddClaim()"
              [disabled]="isAddSaving || !selectedBook || !selectedMember">
        <span *ngIf="isAddSaving" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!isAddSaving" class="pe-7s-bookmarks me-1"></i>Add Claim
      </button>
    </div>

  </div>
</div>


<!-- ═══════════════════════════════════════════════════════════════════════
     ALLOCATE MODAL
════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showAllocateModal"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.55);z-index:1061;" (click)="closeAllocateModal()">
  <div class="card shadow-lg bc-modal-card" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <span class="fw-bold"><i class="pe-7s-pin me-1 text-primary"></i>Allocate Copy</span>
      <button class="btn-close" (click)="closeAllocateModal()"></button>
    </div>

    <div class="card-body p-3">

      <div class="bc-selected-box mb-3">
        <div class="row g-0">
          <div class="col-6">
            <div class="small text-muted">Book</div>
            <div class="fw-bold">{{ allocatingClaim?.bookName }}</div>
          </div>
          <div class="col-4">
            <div class="small text-muted">Member</div>
            <div class="fw-semibold small">{{ allocatingClaim?.memberName }}</div>
          </div>
          <div class="col-2 text-end">
            <div class="small text-muted">Queue pos.</div>
            <div class="fw-bold text-primary">#{{ queuePositionOf(allocatingClaim?.claimId) }}</div>
          </div>
        </div>
      </div>

      <div class="bc-step-label mb-2">Available Copies — Select one to reserve</div>

      <div class="text-center py-3 text-muted small" *ngIf="availableCopies.length === 0">
        <i class="pe-7s-attention me-1"></i>No copies currently available at center.
      </div>

      <div class="bc-copy-grid" *ngIf="availableCopies.length > 0">
        <label *ngFor="let copy of availableCopies"
               class="bc-copy-card" [class.bc-copy-card--selected]="selectedCopyNo === copy.bookSrNo">
          <input type="radio" name="allocateCopy" [value]="copy.bookSrNo" [(ngModel)]="selectedCopyNo" />
          <i class="pe-7s-bookmarks"></i>
          <span class="fw-bold">Copy # {{ copy.bookSrNo }}</span>
        </label>
      </div>

      <div *ngIf="bookQueue2.length > 1" class="bc-queue-mini mt-3">
        <div class="bc-queue-mini-label">Full claim queue for this book:</div>
        <div *ngFor="let q of bookQueue2; let i = index" class="bc-queue-mini-row"
             [class.bc-queue-mini-row--active]="q.claimId === allocatingClaim?.claimId">
          <span class="bc-queue-pos">#{{ i+1 }}</span>
          <span class="small">{{ q.memberName }}</span>
          <span [class]="statusBadgeClass(q.status)" style="font-size:.65rem">{{ q.status }}</span>
        </div>
      </div>

      <div class="alert alert-danger py-2 px-3 small mt-3" *ngIf="allocateError">
        <i class="pe-7s-attention me-1"></i>{{ allocateError }}
      </div>

    </div>

    <div class="card-footer d-flex justify-content-end gap-2 py-2 px-3">
      <button type="button" class="btn btn-secondary btn-sm" (click)="closeAllocateModal()">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" (click)="confirmAllocate()"
              [disabled]="isAllocating || !selectedCopyNo || availableCopies.length === 0">
        <span *ngIf="isAllocating" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!isAllocating" class="pe-7s-check me-1"></i>Confirm Allocation
      </button>
    </div>

  </div>
</div>


<!-- ═══════════════════════════════════════════════════════════════════════
     CANCEL CONFIRM MODAL
════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showCancelModal"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.5);z-index:1062;" (click)="closeCancelModal()">
  <div class="card shadow-lg" style="width:420px;max-width:95vw;" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <span class="fw-bold text-danger"><i class="pe-7s-close-circle me-1"></i>Cancel Claim</span>
      <button class="btn-close" (click)="closeCancelModal()"></button>
    </div>

    <div class="card-body p-3">
      <p class="mb-3 small">
        Cancel the claim for <strong>{{ cancellingClaim?.bookName }}</strong>
        by <strong>{{ cancellingClaim?.memberName }}</strong>?
        <span *ngIf="cancellingClaim?.status === 'allocated'" class="text-warning d-block mt-1">
          <i class="pe-7s-attention me-1"></i>The reserved copy will be released back to available.
        </span>
      </p>
      <label class="form-label small fw-semibold">Reason (optional)</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="cancelReason"
             placeholder="e.g. Member no longer needs the book" />
      <div class="alert alert-danger py-2 px-3 small mt-2" *ngIf="cancelError">
        <i class="pe-7s-attention me-1"></i>{{ cancelError }}
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end gap-2 py-2 px-3">
      <button type="button" class="btn btn-secondary btn-sm" (click)="closeCancelModal()">Keep Claim</button>
      <button type="button" class="btn btn-danger btn-sm" (click)="confirmCancel()" [disabled]="isCancelling">
        <span *ngIf="isCancelling" class="spinner-border spinner-border-sm me-1"></span>
        Yes, Cancel Claim
      </button>
    </div>

  </div>
</div>
